/* eslint-disable no-undef */
import React, { Component } from "react";
import PropTypes from "prop-types";
import { Grid, Popup, List } from "semantic-ui-react";
import history from "../../utils/history";

class UserProfileWidget extends Component {
  render() {
    debugger;
    const { authInfo } = this.props;

    const imgSrc =
      authInfo.fotoPerfil !== "" && authInfo.fotoPerfil !== undefined
        ? authInfo.fotoPerfil
        : "https://s3.us-west-2.amazonaws.com/ixs.dasa.public/userDefault.png";

    return (
      <Popup
        wide
        on={"click"}
        trigger={
          <div className="contenedor-usuario">
            <div
              className="img_perfil_header_popup"
              style={{
                backgroundImage: "url(" + imgSrc + ")",
              }}
            />
          </div>
        }
        position="bottom right"
      >
        <Grid centered divided>
          <Grid.Row>
            <div
              style={{
                backgroundImage: "url(" + imgSrc + ")",
                marginBottom: 5,
                marginTop: 15,
              }}
              className="img_perfil_header_popup2"
            />
          </Grid.Row>

          <div
            style={{
              marginBottom: 10,
              textTransform: "uppercase",
              color: "dimgray",
              fontWeight: "bold",
              fontSize: "1vw",
            }}
          >
            {authInfo.rol}
          </div>

          <Grid.Column
            width={16}
            className={"profile_column"}
            style={{ alignItems: "center" }}
          >
            <List style={{ fontSize: "1vw", margin: 0 }}>
              <List.Item>
                <List.Icon name="user" />
                <List.Content>{authInfo.nombre}</List.Content>
              </List.Item>
              <List.Item>
                <List.Icon name="mail" />
                <List.Content>{authInfo.correo}</List.Content>
              </List.Item>
            </List>
          </Grid.Column>
          <hr style={{ width: "80%", borderColor: "#80bc00" }}></hr>
          <Grid.Column width={16} className={"lista_popup"} textAlign="left">
            <List style={{ fontSize: "1vw" }}>
              <List.Item>
                <List.Content>
                  <a
                    onClick={() => {
                      history.push("/solicitar-cambiar-contrasena");
                    }}
                    className="link-menu"
                  >
                    Cambiar contraseña
                  </a>
                  <br></br>
                  <br></br>
                  <a
                    href
                    onClick={() => {
                      localStorage.removeItem("usuarioLogueado");
                      localStorage.removeItem("DASA_AUTH_JWT_ID");
                      history.push("/");
                    }}
                    className="link-menu"
                  >
                    Cerrar sesión{" "}
                  </a>
                </List.Content>
              </List.Item>
            </List>
          </Grid.Column>
        </Grid>
      </Popup>
    );
  }
}

UserProfileWidget.propTypes = {
  t: PropTypes.func,
  authInfo: PropTypes.object.isRequired,
};

export default UserProfileWidget;
